import React, { Component } from "react";
import { UserContext } from "./userContext";
import { computeEffectivePermissions } from "./permissionsUtils";

class PermissionGate extends Component {
	static contextType = UserContext;

	canPerform() {
		return true;
		const { children, resource, action, ...forwarded } = this.props;
		const user = this.context;
		if (!user) return false;
		const effectivePermissions = computeEffectivePermissions(user);
		const perms = effectivePermissions[resource] || {};
		return perms[action] === true;
	}

	render() {
		const { children, resource, action, ...forwarded } = this.props;

		if (!this.canPerform()) return null;

		const valid = React.Children.toArray(children).filter(React.isValidElement);
		if (valid.length === 0) return null;
		return React.cloneElement(valid[0], forwarded);
	}
}

export default PermissionGate;
